import React from 'react'
import clsx from 'clsx'
interface ButtonProps {
  children?: React.ReactNode
  className?: string
}

const ButtonWrapper = ({children, className = '', ...props}: ButtonProps) => {
  const classNames = clsx('sdx_button_wrapper', className)
  return (
    <div style={{position: 'relative'}}>
      <div className={'sdx_button_wrapper_responsive'}>
        <div className={classNames} {...props}>
          {children}
        </div>
      </div>
    </div>
  )
}

export default ButtonWrapper
